<template>
    <div id="app">
        <router-view v-bind="$data" :columns="columns" :mainBudget="mainBudget" />
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'App', 
        data() { 
            return {
                departments: [],
                expenditures: [],
                ftes: [],
                changes: [],
                resources: []
            }   
        },
        computed: {
            mainBudget: function() {
                // budgetSettings from /public/settings.js
                let mainBudget = budgetSettings; // eslint-disable-line
                
                return mainBudget;
            },
            columns: function(){
                let columns = {};
                    columns.expenditures = this.getYearColumns(this.expenditures[0]);
                    columns.resources = this.getYearColumns(this.resources[0]);
                    columns.changes = this.getYearColumns(this.changes[0]).slice(0,2);

                return columns;
            }
        },
        created: function() {
            if (typeof(this.mainBudget) != 'undefined') {
                this.getDataAndSort('departments','department_or_fund_name');
                this.getDataAndSort('expenditures','bclname');
                this.getDataAndSort('ftes','bclname');
                this.getDataAndSort('changes','report_section');
                this.getDataAndSort('resources','fundname');
            }
        },
        methods: {
            getDataAndSort: function(dataProp, sortBy){
                const backup = (this.mainBudget.backupCache && this.mainBudget.backupCache[dataProp]) ? this.mainBudget.backupCache[dataProp] : ''

                let url = '';

                if (backup.length > 0 && backup.includes('.json')) {
                    url = backup
                }

                if (url.length > 0) {
                    axios.get(backup)
                    .then((res) => {
                        this[dataProp] = res.data.sort(GetSortOrder(sortBy)); 
                    }).catch(() => {
                        console.log('There is no local backup cache response. Does the file exist?')
                    })
                } else {
                    console.log('No backup cache source is specified.')
                }
            },
            getYearColumns: function(obj){
                let years = [],
                    keys = []

                // Grab the property names from the object
                if (obj) keys = Object.keys(obj);

                if (keys.length > 0) {
                    // Filter out year columns by searching for '_20'
                    let matches = keys.filter(value => /(_[0-9]{2})/.test(value)) || [];

                        // Try again for columns by searching for 'sum_of_year' (Older budget change headers)
                        if (matches.length == 0) {
                            matches = keys.filter(value => /(sum_of_year)/.test(value)) || [];
                        }

                    if (matches) years = matches;
                }

                return years;
            }
        }  
    }
    function GetSortOrder(prop) {  
        return function(a, b) {  
            if (a[prop] > b[prop]) {  
                return 1;  
            } else if (a[prop] < b[prop]) {  
                return -1;  
            }  
            return 0;  
        }  
    }    
</script>
